import React, { useMemo } from 'react'
import styled from 'styled-components/macro'
import {
  UserRecord,
  UserState,
} from '@trustero/trustero-api-web/lib/account/account_pb'
import { Gravatar } from 'src/components/Gravatar'
import { useUsers } from 'src/components/async/Users/useUsers'

const DisplayWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`

const OverflowLabel = styled.span`
  color: inherit;
  font-family: Poppins, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0.15px;
  font-feature-settings: 'liga' off, 'clig' off;
  white-space: nowrap;
`

type AssigneeDisplayProps = {
  emails: string[]
}

export const useAssigneeDisplayNames = (): {
  displayName: (email: string) => string
} => {
  const response = useUsers()

  const userByEmail = useMemo(() => {
    const map = new Map<string, UserRecord.AsObject>()
    if (response.data) {
      response.data
        .getUsersList()
        .filter((u) => u.getState() === UserState.USER_ACTIVE)
        .forEach((u) => {
          if (u.getEmail()) map.set(u.getEmail(), u.toObject())
        })
    }
    return map
  }, [response.data])

  return {
    displayName: (email: string) => userByEmail.get(email)?.name || email,
  }
}

export const AssigneeDisplay = ({
  emails,
}: AssigneeDisplayProps): JSX.Element => {
  const first = emails[0] ?? null
  const overflowCount = emails.length - 1

  return (
    <DisplayWrapper>
      <Gravatar email={first} />
      {overflowCount > 0 && (
        <OverflowLabel>+ {overflowCount} more</OverflowLabel>
      )}
    </DisplayWrapper>
  )
}
